import React from 'react';
import './FeaturedCategory.css'




const FeaturedCategory = () => {
    return ( 

    <>



<section className="py-5 py-md-11 bg-white">
        <div className="container wrap-responsive">
            <div className="text-center mb-md-7 mb-4" data-aos="fade-up">
                <h1 className="mb-1" style={{fontWeight: "500", color:"#fff"}}>Our Popular Subjects</h1>
                
            </div>

            <div className="mx-n4" data-flickity='{"pageDots": false, "prevNextButtons": true, "cellAlign": "left", "wrapAround": true, "imagesLoaded": true}'>
                <div className="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="50">

                    <a href="course-list-v3.html" className="card icon-category card-border-hover icon-category border shadow-dark-hover p-md-5 p-3 text-center lift">
            
                        <div className="position-relative" style={{color: "#f0e7f3"}}>
                            <div className="position-absolute bottom-0 right-0 left-0" style={{color: "#B94EE4"}}>
                                <i class="fas fa-bezier-curve"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Creative Arts</h5>
                            <p class="mb-0 line-clamp-1">Practicals and Theory</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="100">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#fcefe9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#F55101"}}>
                            <i class="fa-solid fa-calculator"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Mathematics</h5>
                            <p class="mb-0 line-clamp-1">Practicals and Theory</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="150">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                    
                        <div class="position-relative" style={{color: "#ebf8f9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#00D1EB"}}>
                            <i class="fa-solid fa-book"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>English Language</h5>
                            <p class="mb-0 line-clamp-1">Theory</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="200">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#f6e7e9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#F15571"}}>
                            <i class="fa-solid fa-flask"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Science</h5>
                            <p class="mb-0 line-clamp-1">Theory and Practicals</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="250">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#f0e7f3"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#B94EE4"}}>
                            <i class="fa-solid fa-computer"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>I . C . T</h5>
                            <p class="mb-0 line-clamp-1">Theory and Practicals</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="300">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#fcefe9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#F55101"}}>
                                <i class="fas fa-music"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Music</h5>
                            <p class="mb-0 line-clamp-1">Practicals and Theory</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="350">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#ebf8f9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#00D1EB"}}>
                            <i class="fa-solid fa-person"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Physical Education</h5>
                            <p class="mb-0 line-clamp-1">Practicals and Theory</p>
                        </div>
                    </a>
                </div>

                <div class="col-6 col-lg-4 col-xl-3 pt-2 pb-4 px-md-4 monn monn2 monn3" data-aos="fade-up" data-aos-delay="400">
                    
                    <a href="course-list-v3.html" class="card icon-category card-border-hover border shadow-dark-hover p-md-5 p-3 text-center lift">
                        
                        <div class="position-relative" style={{color: "#f6e7e9"}}>
                            <div class="position-absolute bottom-0 right-0 left-0" style={{color: "#F15571"}}>
                                <i class="fas fa-wallet"></i>
                            </div>
                            
                            <svg width="116" height="82" viewBox="0 0 116 82" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.9238 65.8391C11.9238 65.8391 20.4749 72.4177 35.0465 70.036C49.6182 67.6542 75.9897 78.4406 75.9897 78.4406C75.9897 78.4406 90.002 85.8843 104.047 79.2427C118.093 72.6012 115.872 58.8253 115.872 58.8253C115.743 56.8104 115.606 46.9466 97.5579 22.0066C91.0438 13.0024 84.1597 6.97958 75.9458 3.74641C58.8245 -2.99096 37.7881 -0.447684 22.9067 9.81852C15.5647 14.8832 7.65514 22.0695 3.0465 31.5007C-7.27017 52.6135 11.9238 65.8391 11.9238 65.8391Z" fill="currentColor"/>
                            </svg>

                        </div>

                        
                        <div class="card-footer px-0 pb-0 pt-6">
                            <h5 class="mb-0 line-clamp-1" style={{fontWeight: "600"}}>Social Studies</h5>
                            <p class="mb-0 line-clamp-1">Theory</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </section>


    </> 

    );
}
 
export default FeaturedCategory;